module.exports = __webpack_public_path__ + "img/Geolocation Icon - charcoal.28b384ec.svg";